import { CIcon } from '~/icons/types'
export const ciNotes: CIcon = {
  width: 512,
  height: 512,
  paths: [
    {
      d:
        'M297.5 71h112c4.4 0 8 3.6 8 8v189.9c0 4.4-3.6 8-8 8H252.4c-19.3 0-35 15.7-35 35V433c0 4.4-3.6 8-8 8H102.5c-4.4 0-8-3.6-8-8V268c0-8.8-7.2-16-16-16h-39c-8.8 0-16 7.2-16 16v228c0 8.8 7.2 16 16 16h253.4c8.3 0 16.4-2.9 22.8-8.3l160.1-134.1c8.1-6.7 12.7-16.7 12.7-27.2V16c0-8.8-7.2-16-16-16h-175c-8.8 0-16 7.2-16 16v39c0 8.8 7.2 16 16 16zm-9.1 363v-69.1c0-9.4 7.6-17 17-17h85.8L288.4 434z'
    },
    {
      d:
        'M255.5 84h-72V16c0-8.8-7.2-16-16-16h-40c-8.8 0-16 7.2-16 16v68h-72c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h72v70c0 8.8 7.2 16 16 16h40c8.8 0 16-7.2 16-16v-70h72c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16z'
    }
  ],
  name: 'notes',
  type: 'regular'
}
